import { styled } from "styled-components";

export const Wrapper = styled.section`
  position: absolute;
  bottom: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  p {
    color: var(--text-secondary-color);
    margin: 1rem 0;
  }
`;
